import { UpcomingPaymentBlockView, } from "./UpcomingPaymentBlockView.tsx";

export function UpcomingPaymentBlockModerator() {
  return (
    <UpcomingPaymentBlockView
      isLoading={false}
      isSuccess={true}
      data={[]}
    />
  );
}
